import { useState } from 'react';

export const DEFAULT_SIDEBAR_WIDTH = 300;

export type SidebarApi = [
	{
		isOpen: boolean;
		sidebarWidth: number;
	},
	{
		toggleSidebar: () => void;
	},
];

export type Props = {
	width?: number;
	defaultIsOpen?: boolean;
};

export const usePushingSidebar = ({
	width = DEFAULT_SIDEBAR_WIDTH,
	defaultIsOpen = true,
}: Props): SidebarApi => {
	const [isOpen, setIsOpen] = useState(defaultIsOpen);
	const toggleSidebar = () => {
		setIsOpen((a) => !a);
	};
	return [{ isOpen, sidebarWidth: width }, { toggleSidebar }];
};
